module.exports = __webpack_public_path__ + "img/sequence-suidobashi-sp.61971a0a.jpg";